'use client'

import { Button, styled } from '@mui/material'

export const createBlueStyles = (theme) => ({
  color: 'white',
  border: 'solid 2px transparent',
  backgroundColor: theme.palette.primary.main,
  '&.border': {
    borderColor: `white`,
  },
  '&:hover': {
    boxShadow: 'none !important',
    backgroundColor: 'white',
      border: `solid 2px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      '& svg': {
        fill: theme.palette.primary.main,
      }
  },
})

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'strokeWidth',
})(({ strokeWidth = 0, theme }) => ({
  backgroundColor: 'white',
  color: theme.palette.primary.main,
  borderRadius: theme.spacing(4),
  fontWeight: 700,
  textTransform: 'none',
  padding: theme.spacing(1, 2, 1, 3),
  lineHeight: 1,
  width: 'fit-content',

  svg: {
    stroke: 'currentColor',
    strokeWidth,
    fontSize: '.9rem'
  },
  '&.flex': {
    display: 'flex',
    margin: '0 auto',
  },

  '&.border': {
    border: `2px solid ${theme.palette.primary.main}`,
  },

  '&.blue': {
    ...createBlueStyles(theme),
    '&:hover': {
        backgroundColor: 'white',
        border: `solid 2px ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        '& svg': {
          fill: theme.palette.primary.main
        }
    },
	  '&.custom-hover': {
    '&:hover svg': {
      fill: 'black'
    }
  }
  },
  '&:hover': {
      
  },
  '&.icon-left': {
    svg: {
      marginRight: theme.spacing(1.5),
    },
  },
  '&.icon-right': {
    svg: {
      marginLeft: theme.spacing(1.5),
    },
  },
  '&.alt': {
    svg: {
      marginLeft: theme.spacing(0),
    },
  },
}))
